import { render, staticRenderFns } from "./custom-table-view.vue?vue&type=template&id=a1412fd4&scoped=true&"
import script from "./custom-table-view.vue?vue&type=script&lang=ts&"
export * from "./custom-table-view.vue?vue&type=script&lang=ts&"
import style0 from "./custom-table-view.vue?vue&type=style&index=0&id=a1412fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1412fd4",
  null
  
)

export default component.exports